var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"viewer-container"},[_c('div',{ref:"viewer",staticClass:"pdfViewer"})])}
var staticRenderFns = []

export { render, staticRenderFns }